import { inject, Injectable } from "@angular/core";
import { NbDialogRef, NbDialogService } from "@nebular/theme";
import { InjectorService } from "../@shared/injector.service";




@Injectable({
    providedIn: 'root'
  })
export class DialogService {
    constructor(private dialog: NbDialogService, private injector: InjectorService) { }

    open(component: any, service?: any, method?: string, callback?: Function) {
        this.dialog
            .open(component, { closeOnBackdropClick: false })
            .onClose.subscribe((data) => {
                if (data && data.reload && callback) {
                    const injected = this.injector.get(service);
                    injected[method]().subscribe(((results: any) => {
                        callback(data, results);
                    }))
                }
            });
    }
}